import { cn } from "@/utils/cn";

export const DetailField = ({
  label,
  value,
  href,
  breakWord = false,
}: {
  label: string;
  value: string;
  href?: string;
  breakWord?: boolean;
}) => {
  const breakWordClass = breakWord ? "break-words" : "";
  return (
    <div>
      <dt className="text-xs text-zinc-500">{label}</dt>
      <dd className={cn("text-zinc-700 mt-0.5", breakWordClass)}>
        {href ? (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-zinc-300 underline-offset-2 hover:decoration-zinc-500 hover:text-zinc-900"
          >
            {value}
          </a>
        ) : (
          value
        )}
      </dd>
    </div>
  );
};